<template>
  <div id="card-view--plannings">
    <b-row>
      <b-col
        v-for="(planning, index) in plannings"
        :key="index"
        cols="4"
      >
        <cards-view-card :planning="planning" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import cardsViewCard from './cardsViewCard.vue'

export default {
  components: {
    BRow,
    BCol,
    cardsViewCard,
  },
  props: {
    plannings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>
